import store from '@/store';
import {
  getUnifiedAccountFeatureForReserhub,
  isUnifiedAccountEnabledForClient,
} from 'utils/isReserhubUnifiedAccountEnabled';

/**
 * Whether loyalty widget updates should be ignored in favor of unified account flows.
 *
 * Must stay equivalent to `accountEnabled` in `ReserhubAccountProvider`: both resolve through
 * `isUnifiedAccountEnabledForClient` so the loyalty reducer and the unified account action can never
 * both write `userAuthToken`, where the last write would win nondeterministically.
 *
 * @returns {boolean} True when the Reserhub unified account applies to the current client.
 */
function shouldIgnoreWidgetUpdate() {
  const state = store.getState();
  const account = state.whitelabelConfig?.env?.reserhub?.account;
  return isUnifiedAccountEnabledForClient(account, {
    unifiedAccountFeature: getUnifiedAccountFeatureForReserhub(),
    features: state.whitelabelConfig?.features,
    brand: state.whitelabelConfig?.env?.brand,
  });
}

export default shouldIgnoreWidgetUpdate;
